import React from 'react'
import LinearProgress from '@material-ui/core/LinearProgress'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import { withStyles } from '@material-ui/core'
import Colors from '../../styles/colors.scss'

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    width: 300,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === 'dark' ? 700 : 200],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: Colors.yellow,
  },
}))(LinearProgress)

export const LinearProgressWithLabel = ({ value, props }) => {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <BorderLinearProgress variant="determinate" value={value} />
      </Box>
      <Box>
        <div className="yellow bolder text-body">{`${Math.round(value)}%`}</div>
      </Box>
    </Box>
  )
}
